// extracted by mini-css-extract-plugin
export default {"h1":"text_h1__F9jfv","h2":"text_h2__ItjGU","h4":"text_h4__-0Z6Z","p":"text_p__YHbkk"};